const mutations = {
  setStatus(state, data) {
    state.statusEdit = data
  },
  setDeleteStatus(state, data) {
    state.statusDelete = data
  }
}

export default mutations